/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionAnswerDto
 */
export interface SectionAnswerDto {
    /**
     * 
     * @type {string}
     * @memberof SectionAnswerDto
     */
    sectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionAnswerDto
     */
    sectionType?: SectionAnswerDtoSectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SectionAnswerDto
     */
    statusValue?: SectionAnswerDtoStatusValueEnum;
    /**
     * 
     * @type {number}
     * @memberof SectionAnswerDto
     */
    numericValue?: number;
    /**
     * 
     * @type {string}
     * @memberof SectionAnswerDto
     */
    textValue?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionAnswerDto
     */
    notes?: string;
}


/**
 * @export
 */
export const SectionAnswerDtoSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT'
} as const;
export type SectionAnswerDtoSectionTypeEnum = typeof SectionAnswerDtoSectionTypeEnum[keyof typeof SectionAnswerDtoSectionTypeEnum];

/**
 * @export
 */
export const SectionAnswerDtoStatusValueEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    Warning: 'WARNING',
    NotApplicable: 'NOT_APPLICABLE'
} as const;
export type SectionAnswerDtoStatusValueEnum = typeof SectionAnswerDtoStatusValueEnum[keyof typeof SectionAnswerDtoStatusValueEnum];


/**
 * Check if a given object implements the SectionAnswerDto interface.
 */
export function instanceOfSectionAnswerDto(value: object): value is SectionAnswerDto {
    return true;
}

export function SectionAnswerDtoFromJSON(json: any): SectionAnswerDto {
    return SectionAnswerDtoFromJSONTyped(json, false);
}

export function SectionAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionAnswerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'statusValue': json['statusValue'] == null ? undefined : json['statusValue'],
        'numericValue': json['numericValue'] == null ? undefined : json['numericValue'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function SectionAnswerDtoToJSON(value?: SectionAnswerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sectionId': value['sectionId'],
        'sectionType': value['sectionType'],
        'statusValue': value['statusValue'],
        'numericValue': value['numericValue'],
        'textValue': value['textValue'],
        'notes': value['notes'],
    };
}

